import React from 'react'

export default function ConditionValues({ conditions, field }) {
    return (
        <ul className='sap-direct-condition-values'>
            {conditions?.map((condition, index) => (
                <li key={index} className='sap-direct-condition-value' title={condition[field] || undefined}>
                    {condition[field]}
                </li>
            ))}
        </ul>
    )
}
